export default __webpack_public_path__ + "6e98045d48578548ed25f89c2300f610.png";